import { useEffect, useState } from 'react';
import { ThemeProvider } from '@repo/mfe-core';

import { AgentProvider } from '../shared/app/contexts/AgentContext';
import { MockRouterProvider } from '../shared/app/contexts/MockRouterProvider';
import { useSyncWithHostStore } from '../shared/hooks/host/useSyncWithHostStore';

import '../shared/styles/style.css';

/**
 * Inner component that uses the sync hook
 * This needs to be inside the AgentProvider to access the context
 */
function AppContent() {
  const [isReady, setIsReady] = useState(false);

  // Sync host Redux store state to local context
  useSyncWithHostStore();

  useEffect(() => {
    setIsReady(true);
  }, []);

  if (!isReady) {
    return null;
  }

  return <MockRouterProvider />;
}

export function AppWrapper() {
  return (
    <ThemeProvider>
      <AgentProvider>
        <div data-mfe='agent'>
          <AppContent />
        </div>
      </AgentProvider>
    </ThemeProvider>
  );
}

export default AppWrapper;
